module.exports = __webpack_public_path__ + "static/media/TeamWork.c5217bf1.png";